export var BusinessRFIStatus;
(function (BusinessRFIStatus) {
    /**
     * Holding state for an RFI raised by a processor rather than an admin. The
     * processor tells us it needs more information (dlocal parks a payout at
     * ON_HOLD) but never tells us which documents, so the record exists and is
     * linked to its transaction before anyone knows what to ask for. Admin-only:
     * no notification is sent and the business never sees it, because there is
     * nothing to upload yet. Naming the documents moves it to Requested.
     */
    BusinessRFIStatus["Draft"] = "DRAFT";
    BusinessRFIStatus["Requested"] = "REQUESTED";
    BusinessRFIStatus["Submitted"] = "SUBMITTED";
    BusinessRFIStatus["ReuploadRequested"] = "REUPLOAD_REQUESTED";
    BusinessRFIStatus["Reuploaded"] = "REUPLOADED";
    BusinessRFIStatus["Resolved"] = "RESOLVED";
})(BusinessRFIStatus || (BusinessRFIStatus = {}));
//# sourceMappingURL=BusinessRFIStatus.js.map